import fs from 'fs';

/**
 * Given a file path, returns a human-readable file size description.
 * Returns "?? bytes" if there's some issue getting stats.
 */
export function getFileSizeSync(filePath: string): string {
  let size: number;
  try {
    // Sometimes this throws due to file locks or something
    size = fs.statSync(filePath).size;
  } catch {
    return '?? bytes';
  }

  if (size > 1024 * 1024) {
    return `${(size / 1024 / 1024).toFixed(2)} MB`;
  }

  if (size > 1024) {
    return `${(size / 1024).toFixed(2)} KB`;
  }

  return `${size} ${size === 1 ? 'byte' : 'bytes'}`;
}
